module.exports = __webpack_public_path__ + "img/x.924fb2a9.svg";